export const filterChecked = (data: Record<string, boolean | undefined>) =>
  Object.entries(data).filter(([, y]) => y);
